export enum ApiTypes {
  CLAIM = 'claim',
  PMG = 'pmg',
}
